__turbopack_context__.v({
  "container": "_1JCyRG_container",
  "footerWrapper": "_1JCyRG_footerWrapper",
  "socialWrapper": "_1JCyRG_socialWrapper",
  "titleWrapper": "_1JCyRG_titleWrapper",
});
